import { RootState } from "redux/store";
import { Table } from "components";
import { Link } from "react-router-dom";
import { useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Badge } from "react-bootstrap";
import { SubDepartmentPopup } from "../Popups/SubDepartmentPopup";
import { getSubDepartments, updateDepartmentField, deleteSubDepartment } from "redux/slices/PageMemory/StocksDepartmentPageSlice";

import { updateSubDepartmentField } from "redux/slices/SubDepartment";

type SubDepartmentsProps = {
    departmentId: number;
}

export function SubDepartments(props: SubDepartmentsProps) {
    const dispatch = useAppDispatch();
    const stockDepartmentPageSlice = useAppSelector((state: RootState) => state.stockDepartmentPageSlice);
    const [showSubDepartmentPopup, setShowSubDepartmentPopup] = useState<boolean>(false);

    const columns = [
        {
            Header: "No.",
            accessor: "number",
            defaultCanSort: true,
            width: 120,
            Cell: (row: any) => <Link to={"#"} onClick={() => openSubDeparment(row.cell.row.original.id)}>{row.value}</Link>,
        },
        {
            Header: "Name",
            accessor: "name",
            defaultCanSort: true,
            width: 500,
            Cell: (row: any) => <Link to={"#"} onClick={() => openSubDeparment(row.cell.row.original.id)}>{row.value}</Link>,
        },
        {
            Header: "Status",
            accessor: "locked",
            width: 400,
            Cell: (row: any) => {
                return (
                    <>
                        {row.cell.row.original.locked === true && <Badge className="me-1 badge-outline-danger">Locked</Badge>}
                        {row.cell.row.original.locked === false && <Badge className="me-1 badge-outline-primary">Unlocked</Badge>}
                    </>
                );
            }
        },
    ];

    function selectedRows(selectedRows: number[]){
        let selectedRowIds: number[] = [];
        selectedRows.forEach(rowIndex => {
              selectedRowIds.push(stockDepartmentPageSlice.subDepartments[rowIndex].id);
        });
        dispatch(updateDepartmentField({ key: "selectedSubDepartmentIds", value: selectedRowIds }));
    }

    function openSubDeparment(id: any) {
        dispatch(updateSubDepartmentField({ key: "id", value: id }));
        dispatch(updateSubDepartmentField({ key: "departmentId", value: props.departmentId }));
        setShowSubDepartmentPopup(true);
    }

    function handleDeleteSubDepartment() {
            dispatch(deleteSubDepartment({ ids: stockDepartmentPageSlice.selectedSubDepartmentIds })).then(() => {
            dispatch(getSubDepartments(props.departmentId));
            dispatch(updateDepartmentField({ key: "selectedSubDepartmentIds", value: []}));
        });        
    }

    return (
        <>
            <h4 className="mt-2">Sub Departments</h4>
            <SubDepartmentPopup 
                show={showSubDepartmentPopup}
                onClose={()=> setShowSubDepartmentPopup(false)}
                onSave={() => {
                    dispatch(getSubDepartments(props.departmentId));
                    setShowSubDepartmentPopup(false);
                }}
            />
            <Table
                pageSize={15}
                isSortable={true}
                pagination={true}
                isSelectable={true}
                isSearchable={true}
                columns={columns}
                data={stockDepartmentPageSlice.subDepartments}
                selectedRows={(e)=>selectedRows(e)}
            //    loading={subDepartments.loading}
                removeRows={handleDeleteSubDepartment}
                reloadTableRows={() => {dispatch(getSubDepartments(props.departmentId))}}
                addNewRow={() => setShowSubDepartmentPopup(true)}
            />
        </>
    )
}